export function announceEnqueued(name = '') {
	console.info('Script enqueued: ', name);
}

export function findParent(element, isParent = (element) => false) {
	if (isParent(element)) {
		return element;
	}
	while (! isParent(element)) {
		element = element.parentNode;
	}
	return element;
}

export function getYoutubeThumbnailURL(videoID) {
	return videoID ? `https://img.youtube.com/vi/${videoID}/hqdefault.jpg` : '';
}

export function getPostThumbnailURL(post, size = 'thumbnail') {
	if (! post._embedded) throw new Error('The `_embed` query parameter must be set to true to pluck the thumbnail.');
	if (post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0]) {
		const thumbnail = post._embedded['wp:featuredmedia'][0];
		if (thumbnail.media_type === 'image') {
			if (thumbnail.media_details.sizes[size]) {
				return thumbnail.media_details.sizes[size].source_url;
			} else {
				return thumbnail.source_url;
			}
		}
	}
	return '';
}

export function isURLExternal(url) {
	const urlObj = new URL(url);
	return (urlObj.origin !== window.location.origin);
}
